<template>
  <div>
    <v-tabs v-model="tab" v-show="show" fixed-tabs center-active show-arrows>
      <v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route" flat>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {
  name: "views-administrator-backoffice-tabs-navigation-buttons",
  components: {},
  data: () => ({
    show: true,
    tabs: [],
    tab: 0,
  }),
  created() {
    this.enableButtonsNavigation(this.$route);
  },
  computed: {
    isCollaborator() {
      const user_data = JSON.parse(localStorage.getItem("user_data"));
      return user_data.isCollaborator;
    },
    permissions() {
      const user_data = JSON.parse(localStorage.getItem("user_data"));
      return user_data.permissions;
    },
    hasDocumentVerification() {
      return (
        this.$store.state.operator &&
        this.$store.state.operator.document_verification == "1"
      );
    },
    hasCasino() {
      return this.$store.state.operator &&
        Number(this.$store.state.operator.casino) > 0
        ? true
        : false;
    },
  },
  watch: {
    $route(val) {
      this.enableButtonsNavigation(val);
    },

    hasDocumentVerification(val) {
      if (val) {
        const showDocumentVerification = [
          "AdministratorAccountabilityOnlinePlayersOnlineSearch",
          "PlayersOnlineInactives",
          "ListPlayersOnline",
          "TotalOnlineBalance",
          "DocumentVerification",
          "TagsConfig",
          "CollaboratorAccountabilityOnlinePlayersOnlineSearch",
          "CollaboratorPlayersOnlineInactives",
          "CollaboratorListPlayersOnline",
          "CollaboratorTotalOnlineBalance",
          "CollaboratorDocumentVerification",
        ];

        if (!showDocumentVerification.includes(this.$route.name)) {
          return;
        }

        if (this.isCollaborator && this.$permission("60")) {
          this.tabs.push({
            name: this.$t("documentVerification"),
            route: "/collaborator/players/documentVerification",
          });

          if (this.$route.name === "CollaboratorDocumentVerification") {
            this.tab = "/collaborator/players/documentVerification";
          }
        }

        if (!this.isCollaborator) {
          this.tabs.push({
            name: this.$t("documentVerification"),
            route: "/administrator/administratorPlayers/documentVerification",
          });

          if (this.$route.name === "DocumentVerification") {
            this.tab =
              "/administrator/administratorPlayers/documentVerification";
          }
        }
      }
    },
    hasCasino(val) {
      if (val) {
        this.enableButtonsNavigation(this.$route);
      }
    },
  },
  methods: {
    enableButtonsNavigation(route) {
      // Para adicionar uma nova view na table coloque o Path da rota dentro do Array da view de interesse

      // View de Apostas Online e Relátorio
      const betsOnline = ["AdministratorBetListPlayerOnline", "ChartOnline"];
      // View de Saques e depóitos online
      const extract = [
        "AdministratorAccountabilityOnlineBankStatement",
        "BankStatementByUser",
        "AdministratorAccountabilityOnlineDeposits",
        "ListWithdraws",
      ];

      const collaboratorExtract = [
        "CollaboratorAccountabilityOnlineBankStatement",
        "CollaboratorBankStatementByUser",
        "CollaboratorAccountabilityOnlineDeposits",
        "CollaboratorListWithdraws",
      ];

      // Jogadores Online
      const playersOnline = [
        "AdministratorAccountabilityOnlinePlayersOnlineSearch",
        "PlayersOnlineInactives",
        "ListPlayersOnline",
        "TotalOnlineBalance",
        "DocumentVerification",
        "TagsConfig",
      ];

      const collaboratorPlayersOnline = [
        "CollaboratorAccountabilityOnlinePlayersOnlineSearch",
        "CollaboratorPlayersOnlineInactives",
        "CollaboratorListPlayersOnline",
        "CollaboratorTotalOnlineBalance",
        "CollaboratorDocumentVerification",
        "CollaboratorTagsConfig",
      ];

      // View de Apostas Online e Relátorio
      const bonusAndPromotions = [
        "ListPromotionOnline",
        "ListAdhesions",
        "AdministratorListBonusOnline",
        "ExportPromotionTokens",
        "AdministratorFreespins",
      ];
      // Afiliados Online - Extrato, Ger Regional, Ger Local, Afiliados
      const affiliates = [
        "AdministratorOnlineExtract",
        "AdministratorAffiliatesRevenueShare",
        "AdministratorAffiliatesCpa",
        "AdministratorAffiliatesRegionalManagersList",
        "AdministratorAffiliatesLocalManagersList",
        "AdministratorAffiliatesAffiliatesList",
        "AdministratorAffiliatesPayments",
        "AdministratorAffiliatesPaymentsPay",
        "AdministratorAffiliatesPaymentsHistoric",
        // UI - Apenas para não desaparecer quando abre a dialog
        "AdministratorOnlineAffiliatesRegionalManagersCreate",
        "AdministratorOnlineAffiliatesRegionalManagersEdit",
        "AdministratorOnlineAffiliatesUsersLocalManagersCreate",
        "AdministratorOnlineAffiliatesUsersLocalManagersEdit",
        "AdministratorOnlineAffiliatesUsersAffiliatesCreate",
        "AdministratorOnlineAffiliatesUsersAffiliatesEdit",
        "AdministratorOnlineAffiliatesUsersAffiliatesAnalyticalReport",
        "AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates",
        "AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer",
      ];

      const systemNotifications = [
        "AdministratorSystemNotifications",
        "AdministratorFinalUserNotifications",
        // childrens inseridas para não subir o componente tab
        "AdministratorUserNotificationAdd",
        // "AdministratorUserNotificationEdit",
        "AdministratorUserNotificationDelete",
        "AdministratorUserNotificationSee"

      ];

      const collaboratorBetsTabs = [
        "CollaboratorBetListPlayerOnline",
        "CollaboratorChartOnline",
      ];

      const collaboratorAffiliatesTabs = [
        "CollaboratorOnlineExtract",
        "CollaboratorAffiliatesRenevueShare",
        "CollaboratorAffiliatesCpa",
        "CollaboratorAffiliatesRegionalManagersList",
        "CollaboratorAffiliatesRegionalManagersCreate",
        "CollaboratorAffiliatesRegionalManagersEdit",
        "CollaboratorAffiliatesLocalManagersList",
        "CollaboratorAffiliatesUsersLocalManagersCreate",
        "CollaboratorAffiliatesUsersLocalManagersEdit",
        "CollaboratorAffiliatesAffiliatesList",
        "CollaboratorAffiliatesUsersAffiliatesCreate",
        "CollaboratorAffiliatesUsersAffiliatesEdit",
        "CollaboratorAffiliatesUsersAffiliatesAnalyticalReport",
        "CollaboratorAffiliatesUsersLinkExemptPlayerAffiliates",
        "CollaboratorAffiliatesUsersLinkAffiliateExemptPlayer",
        "CollaboratorAffiliatesPayments",
        "CollaboratorAffiliatesPaymentsPay",
        "CollaboratorAffiliatesPaymentsHistoric",
      ];

      const collaboratorBonusAndPromotionTabs = [
        "CollaboratorListBonusOnline",
        "CollaboratorListPromotionOnline",
        "CollaboratorListAdhesions",
        "CollaboratorFreespins",
      ];

      if (collaboratorBonusAndPromotionTabs.includes(route.name)) {
        this.handleCollaboratorBonusAndPromotionTabs();
      } else if (collaboratorExtract.includes(route.name)) {
        this.handleCollaboratorExtractTabs();
      } else if (collaboratorPlayersOnline.includes(route.name)) {
        this.handleCollaboratorPlayersOnlineTabs();
      } else if (collaboratorBetsTabs.includes(route.name)) {
        this.handleCollaboratorBetsTabs();
      } else if (collaboratorAffiliatesTabs.includes(route.name)) {
        this.handleCollaboratorAffiliatesTabs();
      } else if (betsOnline.includes(route.name)) {
        // Name use for nameDrawer and for Button
        // route is the path the route is going to
        this.tabs = [
          {
            name: this.$t("overview"),
            route: "/administrator/administratorBets/chartOnline",
          },
          {
            name: this.$t("report"),
            route: "/administrator/administratorBets/listBetsOnline",
          },
        ];
        this.show = true;
        this.tab = 0;
      } else if (extract.includes(route.name)) {
        this.tabs = [
          { name: this.$t("extract"), route: "bankStatement" },
          { name: this.$t("byUser"), route: "bankStatementByUser" },
          { name: this.$t("deposits"), route: "listDeposits" },
          { name: this.$t("withdrawals"), route: "listWithdraws" },
        ];
        this.show = true;
        this.tab = 0;
      } else if (playersOnline.includes(route.name)) {
        this.tabs = [
          {
            name: this.$t("labelSearch"),
            route: "/administrator/administratorPlayers/playerOnlineSearch",
          },
          {
            name: this.$t("list"),
            route: "/administrator/administratorPlayers/listPlayersOnline",
          },
          {
            name: this.$t("inactives"),
            route: "/administrator/administratorPlayers/playersOnlineInactives",
          },
          {
            name: this.$t("totalOnlineBalance"),
            route: "/administrator/administratorPlayers/totalOnlineBalance",
          },
          {
            name: this.$t("tagsConfig"),
            route: "/administrator/administratorPlayers/tagsConfig",
          },
        ];
        if (this.hasDocumentVerification) {
          this.tabs.push({
            name: this.$t("documentVerification"),
            route: "/administrator/administratorPlayers/documentVerification",
          });
        }
        this.show = true;
        this.tab = 0;

        if (this.$route.name === "TagsConfig") {
          this.tab = "/administrator/administratorPlayers/tagsConfig";
        }
      } else if (bonusAndPromotions.includes(route.name)) {
        this.tabs = [
          { name: this.$t("sports"), route: "listPromotionOnline" },
          { name: this.$t("bonus"), route: "listBonusOnline" },
        ];

        const showFreespins = true;
        if (this.hasCasino && this.$hasNewCasino() && showFreespins) {
          this.tabs.push({
            name: this.$t("freespins.name"),
            route: "freespins",
          });
        }

        this.show = true;
        this.tab = 0;
      } else if (affiliates.includes(route.name)) {
        this.tabs = [
          {
            name: this.$t("extract"),
            route:
              "/administrator/administratorAffiliates/affiliatesReports/affiliates/adminOnlineOnlineExtract",
          },
          {
            name: this.$t("regionalManagers"),
            route:
              "/administrator/administratorAffiliates/affiliatesReports/affiliates/regional-managers/list",
          },
          {
            name: this.$t("localManagers"),
            route:
              "/administrator/administratorAffiliates/affiliatesReports/affiliates/local-managers/list",
          },
          {
            name: this.$t("affiliates"),
            route:
              "/administrator/administratorAffiliates/affiliatesReports/affiliates/affiliates/list",
          },
          {
            name: this.$t("payments.tab"),
            route:
              "/administrator/administratorAffiliates/affiliatesReports/affiliates/affiliates/payments/",
          },
        ];

        this.show = true;
        this.tab = 0;
      } else if (systemNotifications.includes(route.name)) {
        this.tabs = [
          {
            name: this.$t("system"),
            route:
              "/administrator/system/administratorNotifications/notifications/system",
          },
          {
            name: this.$t("users"),
            route:
              "/administrator/system/administratorNotifications/notifications/notifications",
          },
        ];

        this.show = true;
        this.tab = 0;
      } else {
        this.show = false;
      }
    },
    handleCollaboratorBetsTabs() {
      this.tabs = [];

      const canChartOnline = this.$permission("1");
      const canListOnline = this.$permission("2");

      if (canChartOnline) {
        this.tabs.push({
          name: this.$t("overview"),
          route: "/collaborator/collaboratorBets/chartOnline",
        });
      }

      if (canListOnline) {
        this.tabs.push({
          name: this.$t("report"),
          route: "/collaborator/collaboratorBets/listOnline",
        });
      }

      this.show = true;
      this.tab = 0;
    },
    handleCollaboratorAffiliatesTabs() {
      this.tabs = [];

      const canListOnlineExtract =
        this.$permission("61") || this.$permission("122");
      const canListRegionalAffiliates = this.$permission("13");
      const canListLocalAffiliates = this.$permission("12");
      const canListAffiliates = this.$permission("14");
      const canSeePaymentsTab =
        this.$permission("105") || this.$permission("106");

      if (canListOnlineExtract) {
        this.tabs.push({
          name: this.$t("extract"),
          route: "/collaborator/affiliates/affiliatesReports/extract",
        });
      }

      if (canListRegionalAffiliates) {
        this.tabs.push({
          name: this.$t("regionalManagers"),
          route: "/collaborator/affiliates/affiliatesReports/regional-managers/list",
        });
      }

      if (canListLocalAffiliates) {
        this.tabs.push({
          name: this.$t("localManagers"),
          route: "/collaborator/affiliates/affiliatesReports/local-managers/list",
        });
      }

      if (canListAffiliates) {
        this.tabs.push({
          name: this.$t("affiliates"),
          route: "/collaborator/affiliates/affiliatesReports/affiliates/list",
        });
      }

      if (canSeePaymentsTab) {
        this.tabs.push({
          name: this.$t("payments.tab"),
          route: "/collaborator/affiliates/affiliatesReports/payments",
        });
      }

      this.show = true;
      this.tab = 4;
    },
    handleCollaboratorPlayersOnlineTabs() {
      this.tabs = [];

      const canSearchPlayer = this.$permission("25");
      const canListOnlinePlayers = this.$permission("32");
      const canAccessInactiveTab = this.$permission("30");
      const canAccessTotalOnlineBalanceTab = this.$permission("35");
      const canAccessDocumentVerificationTab =
        this.hasDocumentVerification && this.$permission("60");
      const canAccessTagsConfigTab = this.$permission("140");

      if (canSearchPlayer) {
        this.tabs.push({
          name: this.$t("labelSearch"),
          route: "/collaborator/players/playerOnlineSearch",
        });
      }

      if (canListOnlinePlayers) {
        this.tabs.push({
          name: this.$t("list"),
          route: "/collaborator/players/listPlayersOnline",
        });
      }

      if (canAccessInactiveTab) {
        this.tabs.push({
          name: this.$t("inactives"),
          route: "/collaborator/players/playersOnlineInactives",
        });
      }

      if (canAccessTotalOnlineBalanceTab) {
        this.tabs.push({
          name: this.$t("totalOnlineBalance"),
          route: "/collaborator/players/totalOnlineBalance",
        });
      }

      if (canAccessDocumentVerificationTab) {
        this.tabs.push({
          name: this.$t("documentVerification"),
          route: "/collaborator/players/documentVerification",
        });
      }

      if (canAccessTagsConfigTab) {
        this.tabs.push({
          name: this.$t("tagsConfig"),
          route: "/collaborator/players/tagsConfig",
        });
      }

      this.show = true;
      this.tab = 0;

      if (this.$route.name === "CollaboratorTagsConfig") {
        this.tab = "/collaborator/players/tagsConfig";
      }
    },
    handleCollaboratorExtractTabs() {
      this.tabs = [];

      const canListBankStatement = this.$permission("63");
      const canListBankStatementByUser = this.$permission("64");
      const canListWithdraws = this.$permission("5");
      const canListDeposits = this.$permission("7");

      if (canListBankStatement) {
        this.tabs.push({
          name: this.$t("extract"),
          route: "/collaborator/withdrawsAndDeposits/bankStatement",
        });
      }

      if (canListBankStatementByUser) {
        this.tabs.push({
          name: this.$t("byUser"),
          route: "/collaborator/withdrawsAndDeposits/bankStatementByUser",
        });
      }

      if (canListDeposits) {
        this.tabs.push({
          name: this.$t("deposits"),
          route: "/collaborator/withdrawsAndDeposits/listDeposits",
        });
      }

      if (canListWithdraws) {
        this.tabs.push({
          name: this.$t("withdrawals"),
          route: "/collaborator/withdrawsAndDeposits/listWithdraws",
        });
      }

      this.show = true;
      this.tab = 0;
    },
    handleCollaboratorBonusAndPromotionTabs() {
      this.tabs = [];

      const canListBonus = this.$permission("8");
      const canListPromotions = this.$permission("4");
      const showFreespins = true;
      const canManageFreespins =
        this.$permission("119") &&
        this.hasCasino &&
        this.$hasNewCasino() &&
        showFreespins;

      if (canListPromotions) {
        this.tabs.push({
          name: this.$t("sports"),
          route: "/collaborator/bonusAndPromotions/listPromotionOnline",
        });
      }

      if (canListBonus) {
        this.tabs.push({
          name: this.$t("bonus"),
          route: "/collaborator/bonusAndPromotions/listBonusOnline",
        });
      }

      if (canManageFreespins) {
        this.tabs.push({
          name: this.$t("freespins.name"),
          route: "/collaborator/bonusAndPromotions/freespins",
        });
      }

      this.show = true;
      this.tab = 0;
    },
  },
};
</script>
